import React from 'react';
import { FaArrowLeft, FaRedo, FaCalendar, FaClock, FaInfoCircle } from 'react-icons/fa';
import Logo from '../../assets/Images/Docusafe_logo.webp';

const ReviewHeader = ({
  negotiationData,
  isRefreshing,
  onRefresh,
  onBack,
  onContractInfoClick
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return 'N/A';
    }
  };

  if (!negotiationData) {
    return (
      <header className="review-header shadow-sm">
        <div className="container-fluid review-header-container">
          <div className="review-header-left">
            <img src={Logo} alt="" className="docusafe_logo" />
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="review-header shadow-sm">
      <div className="container-fluid review-header-container">
        <div className="review-header-left">
          <img src={Logo} alt="" className="docusafe_logo" />
        </div>

        <div className="review-header-right d-flex align-items-center">
          <div className="review-header-info d-flex">
            <div className="review-info-item me-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar h-5 w-5 text-primary"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>
              <div className="review-info-text">
                <span className="review-info-label fw-semibold">Due Date</span>
                <span className="review-info-value">
                  {negotiationData?.due_date_format ||
                    formatDate(negotiationData?.due_date) ||
                    'N/A'}
                </span>
              </div>
            </div>
            <div className="review-info-item me-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock h-5 w-5 text-primary"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>              <div className="review-info-text">
                <span className="review-info-label fw-semibold">Remaining</span>
                <span className="review-info-value">
                  {Math.max(0, parseInt(negotiationData?.due_days || 0))} days
                </span>
              </div>
            </div>
          </div>
          <button
            className="contract-info-btn ms-2"
            title="Show Contract Info"
            style={{ background: "none", border: "none", cursor: "pointer", outline: "none" }}
            onClick={onContractInfoClick}
          >
            <FaInfoCircle size={22} color="#516cf0" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default ReviewHeader;
